<template>
    <v-container>
        <v-row class="center">
            <v-col cols="12">
                <v-card style="position: relative;" :height="calendarHeight">
                    <div
                        style="position: absolute; top: 25%; left: 15%; width: 65%; height: 30%;"
                        id="attachArea"
                    ></div>
                    <h2>{{ partnerName }} Scheduled Events</h2>
                    <!-- Calendar for days of week Mon,Tues,Wed,Thur,Fri,Sat,Sun --->
                    <v-calendar @click:event="showEvent" v-model="tempVal" :events="events" type="month">
                        <template v-slot:event="{ event, eventSummary }">
                            <v-menu class="col-10" :attach="'#attachArea'" :close-on-click="false" :close-on-content-click="false"
                                v-model="event.open" fixed>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-flex v-on="on" v-bind="attrs" style="flex-direction: column;" class="center">
                                        <v-row><p v-html="eventSummary()"></p></v-row>
                                    </v-flex>
                                </template>
                                <v-card color="grey lighten-4" flat>
                                    <v-flex>
                                        <v-row class="center">
                                            <v-col cols="5">
                                                <v-text-field label="Event Name" @input="dealChange" v-model="event.name"></v-text-field>
                                            </v-col>
                                            <v-col cols="5">
                                                <v-text-field label="Description" @input="dealChange" v-model="event.description"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="center">
                                            <v-col cols="5">
                                                <v-text-field
                                                    v-model="event.dealValue"
                                                    @input="dealChange"
                                                    type="number"
                                                    label="Deal Value"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-flex>
                                    <v-card-actions class="end">
                                        <v-btn text color="secondary" @click="event.open = false">
                                            Details Page
                                        </v-btn>
                                        <v-btn text color="red" @click="cancelEvent(event)">
                                            Cancel Event
                                        </v-btn>
                                        <v-btn text color="secondary" @click="event.open = false">
                                            Close
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </template>
                    </v-calendar>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<style lang="scss" scoped>
::v-deep .v-menu__content{
    max-width: none;
    width: 100%;
}
</style>

<script>
import utils from '../../utilities/utils';

export default {
    data: () => ({
        tempVal: null,
        events: [],
        eventDates: [{
            _id: '1',
            eventName: 'Test Event',
            requestingPartner: '',
            geoHashGroup: '',
            customerSearchTags: [],
            description: '',
            startTime: '21:30',
            endTime: '23:30',
            locationType: 2,
            dates: [
                '2022-09-08T00:00:00.000+00:00',
                '2022-09-11T00:00:00.000+00:00'
            ],
            traffic: {
                entries: [],
                totalTraffic: 0
            }
        }]
    }),
    created() {
        this.events = this.eventDates.map((s) => {
            return {
                id: s._id,
                name: s.eventName,
                description: s.description,
                start: utils.combineDateTime(s.dates[0], s.startTime),
                end: s.dates[1] ? utils.combineDateTime(s.dates[1], s.endTime) : utils.combineDateTime(s.dates[0], s.endTime),
                color: 'blue',
                allDay: false,
                open: false
            }
        });
    },
    methods: {
        // verifyEmail(){

        // },
        cancelEvent(event){
            console.log(event);
        },
        dealChange(){
            
        },
        showEvent({ nativeEvent, event }) {
            event.open = true
            nativeEvent.stopPropagation()
        }
    },
    computed: {
        partnerName(){
            return this.$store.getters.partnerName;
        },
        calendarHeight() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '450'
                default:
                    return '500'
            }
        }    
    }
}
</script>
